module.exports = __webpack_public_path__ + "assets/img/Future_008.01405a7e-ps.jpg";